<ion-button
  class="status-btn"
  fill="outline"
  size="large"
  color="medium"
  (click)="addNewNotes()"
>
  <ion-icon name="add" class="ion-float-left"></ion-icon>
  <ion-text text-regular class="mrg-5">Add Note</ion-text>
</ion-button>
